module.exports = "/images/Scooter.png?abb2b4cfc5d489fa3083e5c82d91fc3c";